import React, { useEffect, useRef, useState } from "react";
import { StyledClientDescription } from "../../clients/styledClients";
import { StyledEventLogs } from "../../logs/styledLogs";
import { StyledBreakWord } from "../../styles/styledBreakWord";

const DescriptionItemShow = ({description, t}) => {
  const [showMore, setShowMore] = useState(false);

  return(
    <>
      <StyledClientDescription>
        <StyledBreakWord as="p">
          <b>
            {description
              ? (showMore ? description : description.length > 50 ? `${description.substring(0, 50).trim()}...` : description)
              : t("table.empty")}
          </b>
        </StyledBreakWord>
      </StyledClientDescription>
      {description?.length > 50 && (
        <button className="read-more" onClick={() => setShowMore(!showMore)}>
          {showMore ? t("table.hide") : t("table.detail")}
        </button>
      )}
    </>
  );
}

export default DescriptionItemShow;